module.exports = __webpack_public_path__ + "static/img/qp3.b81823a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qp3.png
// module id = cDaY
// module chunks = 2